import React from "react";
import dummyImage from "../../../img/image.png";

const StaffSideTag = ({ staff }) => {
    return (
        <>
            <div className="card">
                <div className="card-body bg-success p-5" style={{ borderRadius: "12px" }}>
                    <center>
                        <div
                            style={{
                                backgroundImage: `url(${staff.image || dummyImage}`,
                                width: "120px",
                                height: "120px",
                            }}
                            className="img-container user-img-circle"
                        ></div>
                    </center>
                </div>
            </div>

            <div className="card">
                <div className="card-head">
                    <header>Basic Info</header>
                    <div className="tools">
                        <a className="t-collapse btn-color fa fa-chevron-down" href="javascript:;"></a>
                    </div>
                </div>
                <div className="card-body">
                    <div className="profile-userpic"></div>
                    <div className="profile-usertitle">
                        <div className="profile-usertitle-name">
                            {staff.first_name} {staff.middle_name} {staff.surname}{" "}
                        </div>
                        <div className="profile-usertitle-job">
                            {staff.type.name} | <strong className="text-success">{staff.designation.name}</strong>
                        </div>
                        <div className="m-3 text-center">
                            {staff.admin && (
                                <i title="Admin" className="material-icons text-success fade-in">
                                    check_circle
                                </i>
                            )}
                            {staff.topStaff && (
                                <i title="Top Staff" className="material-icons text-primary fade-in">
                                    verified_user
                                </i>
                            )}
                        </div>
                    </div>
                    <ul className="list-group list-group-unbordered">
                        <li className="list-group-item">
                            <b>Email</b> <label className="pull-right">{staff.email}</label>
                        </li>
                        <li className="list-group-item">
                            <b>Phone No</b>
                            <label className="pull-right">{staff.mobile}</label>
                        </li>
                        <li className="list-group-item">
                            <b>Gender</b> <label className="pull-right">{staff.gender}</label>
                        </li>
                        <li className="list-group-item">
                            <b>Post Code</b> <label className="pull-right">{staff.postal_code || "Nil"}</label>
                        </li>
                        <li className="list-group-item">
                            <b>Contact Address</b> <label className="pull-right">{staff.contact_address || "Nil"}</label>
                        </li>
                        {staff.site && (
                            <li className="list-group-item">
                                <b>Site</b> <label className="pull-right">{staff.site.name}</label>
                            </li>
                        )}
                        {staff.type && (
                            <li className="list-group-item">
                                <b>Type</b> <label className="pull-right">{staff.type.name}</label>
                            </li>
                        )}
                        <li className="list-group-item">
                            <b>Dept</b> <label className="pull-right">{staff.department.name}</label>
                        </li>
                        {staff.created_at && (
                            <li className="list-group-item">
                                <b>Date Of Joining</b>{" "}
                                <label className="pull-right">
                                    {Intl.DateTimeFormat("en-GB", {
                                        month: "short",
                                        year: "numeric",
                                        weekday: "short",
                                        day: "numeric",
                                    }).format(new Date(staff.created_at))}
                                </label>
                            </li>
                        )}
                    </ul>
                </div>
            </div>
        </>
    );
};

export default StaffSideTag;
